import { App, type URLOpenListenerEvent } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

/**
 * Initialize deep link listener for Capacitor mobile app.
 * Handles both app launch URLs and URLs received while app is running.
 *
 * Deep links use custom URL scheme: clipboardworks.workplace://path?params
 * Example: clipboardworks.workplace://mobile/calendar
 */
export function initializeDeepLinkHandler(onDeepLink: (url: string) => void): () => void {
  if (!Capacitor.isNativePlatform()) {
    return () => {
      // No-op for web
    };
  }

  let cleanup: (() => void) | undefined;

  void (async () => {
    // Check if app was launched via deep link
    const launchUrl = await App.getLaunchUrl();
    if (launchUrl?.url) {
      onDeepLink(String(launchUrl.url));
    }

    // Listen for deep links while app is running
    const listener = await App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
      onDeepLink(String(event.url));
    });

    cleanup = () => {
      void listener.remove();
    };
  })();

  return () => {
    cleanup?.();
  };
}
